(function () {
    pagination(false);

    // https://forum.ghost.org/t/removing-powered-by-ghost/29558/3
    window.onload = function () {
        let portal = document.getElementById("ghost-portal-root");
        const interval = setInterval(() => {
            let frame = portal.querySelector('[title="portal-popup"]');
            if (frame !== null) {
                const styleElement = document.createElement("style");
                styleElement.innerHTML = `.gh-portal-powered { display: none; }`;
                frame.contentDocument.head.appendChild(styleElement);
            } else {
                frame = null
            }
        }, 100)
    }


})();